// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosServicos_SalvaCompromissoServicoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /compromissos_servicos/salvaCompromissoServico
 *
 * Validates UPDATE of compromisso_servico record.
 * Only compromisso_servico_id is required (PK for update), all other fields optional.
 */
import { registerContract } from './validate'

export interface CompromissosServicos_SalvaCompromissoServicoInput {
compromisso_servico_id: number
compromisso_id?: number
orcamento_servico_id?: number
compromisso_servico_status?: number
compromisso_servico_qtd?: number
compromisso_servico_valor?: number
compromisso_servico_data_cadastro?: string
}

registerContract('CompromissosServicos_SalvaCompromissoServicoInput', {
  compromisso_servico_id:            { type: 'number',  required: true },
  compromisso_id:                    { type: 'number',  required: false },
  orcamento_servico_id:              { type: 'number',  required: false },
  compromisso_servico_status:        { type: 'number',  required: false },
  compromisso_servico_qtd:           { type: 'number',  required: false },
  compromisso_servico_valor:         { type: 'number',  required: false },
  compromisso_servico_data_cadastro: { type: 'string',  required: false },
})
